<template>
    <v-dialog
        :model-value="showModal"
        @update:model-value="cancelDelete"
        :fullscreen="$vuetify.display.mobile"
        :max-width="$vuetify.display.mobile ? '100%' : '400'"
    >
        <v-card>
            <v-card-title class="headline">
                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <span>Are you sure?</span>
                    <v-btn icon @click="cancelDelete">
                        <v-icon>fas fa-times</v-icon>
                    </v-btn>
                </div>
            </v-card-title>
            <v-card-text>
                <p>Deletions cannot be undone.</p>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="cancelDelete">Cancel</v-btn>
                <v-btn color="error" variant="flat" @click="handleConfirmDelete">Delete</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
    name: 'DeleteConfirmationModal',
    props: {
        itemData: String,
    },
    setup(props, context) {
        const store = useStore();
        const showModal = computed(() => store.state.showDeleteConfirmationModal);

        const handleConfirmDelete = () => {
            context.emit('confirm-delete', props.itemData);
            store.commit('SET_SHOW_DELETE_CONFIRMATION_MODAL', false);
        };

        const cancelDelete = () => {
            context.emit('cancel-delete');
        };

        return {
            showModal,
            handleConfirmDelete,
            cancelDelete,
        };
    },
};
</script>
